window.requestAnimFrame = (function() {
  return  window.requestAnimationFrame       ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame    ||
    window.oRequestAnimationFrame      ||
    window.msRequestAnimationFrame     ||
    function(callback, element) {
      window.setTimeout(callback, 1000 / 60)
    }
})()

export const requestTimeout = function(fn, delay) {
  if( !window.requestAnimationFrame       &&
    !window.webkitRequestAnimationFrame &&
    !(window.mozRequestAnimationFrame && window.mozCancelRequestAnimationFrame) &&
    !window.oRequestAnimationFrame      &&
    !window.msRequestAnimationFrame)
    return window.setTimeout(fn, delay)

  var start = new Date().getTime(),
    handle = new Object()

  function loop(){
    var current = new Date().getTime(),
      delta = current - start

    delta >= delay ? fn.call() : handle.value = requestAnimFrame(loop)
  };

  handle.value = requestAnimFrame(loop)
  return handle
}

export const getHeaderOffset = () => {
  if (window.innerWidth >= 768) {
    return 70
  }

  if (window.innerWidth >= 1024) {
    return 66
  }

  return 55
}
